require('./mortgageRequestPayMarketingCountry.scss');
// @ vendors
const React = require('react');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ commons
const { OKLink } = require('commonsComponents/OKLink');

const MortgageRequestPayMarketingCountry = () => {
    const link = formatText('mortgageRequestPay-mortgageRequestPay_marketingCountryLinkUrl');

    return (
        <div className="mortgage-request-pay-marketing-country">
            <FormattedText value="mortgageRequestPay-mortgageRequestPay_marketingCountryText" />
            <div className="mortgage-request-pay-marketing-country__link">
                <OKLink modifier="emphasize" to={link} target="_blank">
                    <FormattedText value="mortgageRequestPay-mortgageRequestPay_marketingCountryLinkText" />
                </OKLink>
            </div>
        </div>
    );
};

module.exports = MortgageRequestPayMarketingCountry;
